import { RootState } from "../../../../../../store";

import { commitmentsDataForGranularSelector } from "../../commitmentsDataForGranularSelector";

export const savingsPlansGranularDataUncoveredUsageSelector = (
  state: RootState,
) => {
  const data = commitmentsDataForGranularSelector(state);

  return data?.date_granular_data?.uncovered_usage;
};
